// EXTERNAL DEPENDENCIES
import React, { useEffect, useRef } from 'react'

// COMPONENTS
import ProfileCard from '@/common/components/ui/profile/profile-card'

//HELPERS
import { useBusinessProfileReduxState } from '../../hooks'

//CONSTANTS
import { BUYER_CLICKED_PAY_BUTTON_FPTI } from '../../constants/fpti-constants'

// FPTI
import { trackImpression } from '@/utils'
import {
  BUSINESS_PROFILE_BUYER_VIEW_SHARE_CLICK_FPTI,
  BUSINESS_PROFILE_PAGE_SHOWN_TO_BUYER,
  BUSINESS_PROFILE_PAGE_SHOWN_TO_SELLER,
  BUSINESS_PROFILE_SELLER_SHARE_LINK_CLICK_FPTI,
} from './fpti'

//TEST ID
import { BUSINESS_PROFILE_INDEX_PAGE_CONTAINER_TEST_ID } from '../../constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * The EditProfileSheet displays the profile information with edit buttons next to the editable fields
 */
export function ViewProfilePage() {
  const pageImpressionTracked = useRef(null)
  const state = useBusinessProfileReduxState()

  const {
    address,
    avatarUrl,
    backgroundUrl,
    businessDescription,
    businessJoinDate,
    businessName,
    canEdit,
    customerCount,
    emailAddress,
    flowData,
    handle,
    phoneNumber,
    profilePreferences,
    website,
  } = state.profileData || {}

  useEffect(() => {
    if (typeof canEdit === 'boolean' && !pageImpressionTracked.current) {
      pageImpressionTracked.current = true

      const impressionToTrack = canEdit
        ? BUSINESS_PROFILE_PAGE_SHOWN_TO_SELLER
        : BUSINESS_PROFILE_PAGE_SHOWN_TO_BUYER

      trackImpression({ ...impressionToTrack, withMetrics: true })
    }
  }, [canEdit])

  return (
    <div
      className={styles.profileContainer}
      data-testid={BUSINESS_PROFILE_INDEX_PAGE_CONTAINER_TEST_ID}
    >
      <ProfileCard
        fpti={{
          flowData,
          eventName: BUYER_CLICKED_PAY_BUTTON_FPTI,
          shareLinkFpti: canEdit
            ? BUSINESS_PROFILE_SELLER_SHARE_LINK_CLICK_FPTI
            : BUSINESS_PROFILE_BUYER_VIEW_SHARE_CLICK_FPTI,
        }}
        data={{
          businessDescription,
          businessName,
          accountCreateDate: businessJoinDate,
          businessAddress: address,
          businessHandle: handle,
          contactInfo: {
            businessEmail: emailAddress,
            businessPhoneNumber: phoneNumber,
            businessWebsiteUrl: website,
          },
          coverPhotoSrc: backgroundUrl,
          pastYearCustomerCount: customerCount,
          profilePhotoSrc: avatarUrl,
          selectedLocationDisplayPreference:
            profilePreferences?.locationDisplayPreference,
        }}
        isLoading={!businessName}
        userOwnsProfile={canEdit}
      />
    </div>
  )
}
